import React from 'react';
import { Layout, Spin } from 'antd';

export interface LoadingProps {
  size?: 'small' | 'default' | 'large';
}

const Loading = ({ size }: React.PropsWithChildren<LoadingProps>): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Layout
      className="auth"
      style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <Spin size={size} />
    </Layout>
  );
};

export default Loading;
